import { Injectable } from '@angular/core';
import { select, Store, Action } from '@ngrx/store';

import * as fromSubscriptions from './subscriptions.reducer';
import * as SubscriptionsSelectors from './subscriptions.selectors';
import * as SubscriptionsActions from './subscriptions.actions';

@Injectable()
export class SubscriptionsFacade {
  // Selectors
  loading$ = this.store.pipe(
    select(SubscriptionsSelectors.getSubscriptionsLoading)
  );
  activeSubscription$ = this.store.pipe(
    select(SubscriptionsSelectors.getActiveSubscription)
  );
  subscriptions$ = this.store.pipe(
    select(SubscriptionsSelectors.getAllSubscriptions)
  );
  accountSubscriptions$ = this.store.pipe(
    select(SubscriptionsSelectors.getSubscriptionsEntities)
  );
  error$ = this.store.pipe(
    select(SubscriptionsSelectors.getSubscriptionsError)
  );

  constructor(
    private store: Store<fromSubscriptions.SubscriptionsPartialState>
  ) {}

  private dispatch(action: Action) {
    this.store.dispatch(action);
  }

  loadSubscriptions() {
    this.dispatch(SubscriptionsActions.getSubscriptions());
  }

  getSubscription(id: string) {
    this.dispatch(SubscriptionsActions.getSubscription({ id }));
  }

  pauseSubscription(id: string) {
    this.dispatch(
      SubscriptionsActions.updateSubscription({
        id,
        updates: { status: 'paused' }
      })
    );
  }

  resumeSubscription(id: string) {
    this.dispatch(
      SubscriptionsActions.updateSubscription({
        id,
        updates: { status: 'active' }
      })
    );
  }

  changeNextCycleDate(id: string, nextCycleDate: Date) {
    this.dispatch(
      SubscriptionsActions.updateSubscription({
        id,
        updates: { nextCycleDate }
      })
    );
  }
}
